import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ProblemActionBody from "./ProblemActionBody";
import ProblemDescriptionMobile from "./ProblemDescriptionMobile";
import { rowsPerPageOptions } from "../../utils/problemConstants";
import {
  dashboardBodyTemplate,
  diTanganiBodyTemplate,
  durasiBodyTemplate,
  kendaraanJenisBodyTemplate,
  groupKeteranganBodyTemplate,
  tanggalBodyTemplate,
} from "../../utils/problemTemplates";

// small paginator for mobile: buttons of 2rem instead of 3rem, small text
const mobilePaginatorClassName =
  "w-100 !px-0 !py-1 !gap-1 [&_.p-paginator-element]:!min-w-[2rem] [&_.p-paginator-element]:!h-[2rem] [&_.p-paginator-current]:!min-w-0 [&_.p-paginator-current]:!h-[2rem] [&_.p-paginator-current]:!text-xs";

// One card with a table of problems.
//   highlight: the red "PROBLEM BARU" card (last 7 days), otherwise the plain "PROBLEM LAMA" card
//   sortable / formatLabelGrup: what differs between problem kendaraan and problem trado
//   sortable: { no, description } columns that can be sorted
//   paging: { first, rows } of the table (local paging), onPage: called by the paginator of the table
//   handlers: { permittedToEdit, onEdit, onDelete, onClickImage, onClickShowPengecekan }
const ProblemTableCard = ({
  title,
  highlight,
  value,
  selection,
  setSelection,
  loading,
  paging,
  onPage,
  isMobile,
  sortable,
  formatLabelGrup,
  handlers,
}) => {
  // the red card colors the header of every column
  const head = (className) =>
    highlight
      ? className
        ? `${className} bg-red-300`
        : "bg-red-300"
      : className;

  const groupKeteranganTemplate = (row) =>
    groupKeteranganBodyTemplate(
      row,
      row.label_grup && row.label_grup.length > 0
        ? formatLabelGrup(row.label_grup)
        : ""
    );

  const actionBodyTemplate = (row) => (
    <ProblemActionBody row={row} {...handlers} />
  );

  const descriptionMobileBodyTemplate = (rowData) => (
    <ProblemDescriptionMobile
      rowData={rowData}
      formatLabelGrup={formatLabelGrup}
      {...handlers}
    />
  );

  return (
    <div
      className={`col-center-center w-100 gap-3${
        highlight ? " p-4 rounded-lg !bg-red-100 border-red-500 border-2" : ""
      }`}
    >
      <div className={`row-between-center gap-2 w-100`}>
        <div className="row-start-center gap-2">
          <span className="text-sm font-semibold text-zinc-700">{title}</span>
        </div>
      </div>

      <div className={`row-center-center gap-2 w-100`}>
        <DataTable
          sortMode="multiple"
          dataKey="id"
          className="w-100"
          loading={loading}
          showGridlines
          stripedRows
          editMode="cell"
          value={value}
          paginator
          first={paging.first}
          rows={paging.rows}
          onPage={onPage}
          paginatorClassName={`${highlight ? "bg-red-100" : ""} ${
            isMobile ? mobilePaginatorClassName : ""
          }`}
          // mobile: small, no page numbers and no rows per page, only "< 1 / 3 (25) >"
          {...(isMobile
            ? {
                paginatorTemplate: "PrevPageLink CurrentPageReport NextPageLink",
                currentPageReportTemplate:
                  "{currentPage} / {totalPages} ({totalRecords})",
              }
            : { rowsPerPageOptions })}
          selection={selection}
          onSelectionChange={(e) => setSelection(e.value)}
          rowClassName={(data) => {
            if (data.tanggal_selesai) return "bg-green-50";
            return highlight ? "bg-red-50" : "bg-white";
          }}
        >
          {/* "#" is not shown on mobile (DESKRIPSI takes its place) */}
          {!isMobile && (
            <Column
              sortable={sortable.no}
              header="#"
              field="no"
              headerClassName={head("w-[2.5rem]")}
              className="text-right"
              alignHeader={"right"}
            />
          )}

          {isMobile && (
            <Column
              sortable={sortable.description}
              header="DESKRIPSI"
              headerClassName={head("text-xs")}
              className="!p-0"
              alignHeader={"left"}
              body={descriptionMobileBodyTemplate}
            />
          )}

          {/* <Column headerClassName="w-[3rem]" selectionMode={"multiple"} /> */}

          {!isMobile && (
            <Column
              header="Action"
              alignHeader={"center"}
              headerClassName={head("w-[9rem]")}
              body={actionBodyTemplate}
            />
          )}

          {!isMobile && (
            <Column
              sortable
              field="tanggal"
              header="Tanggal"
              headerClassName={head()}
              body={tanggalBodyTemplate}
            />
          )}

          {!isMobile && (
            <Column
              field="durasi"
              header="Durasi"
              headerClassName={head()}
              body={durasiBodyTemplate}
            />
          )}

          {!isMobile && (
            <Column
              sortable
              field="data_kendaraan.nomor_polisi"
              header="Kendaraan"
              headerClassName={head()}
              body={kendaraanJenisBodyTemplate}
            />
          )}

          {!isMobile && (
            <Column
              sortable
              field="label_grup"
              header="Group"
              headerClassName={head()}
              body={groupKeteranganTemplate}
            />
          )}

          {!isMobile && (
            <Column
              sortable
              field="show_dashboard"
              header="Dashboard"
              headerClassName={head()}
              body={dashboardBodyTemplate}
            />
          )}

          {!isMobile && (
            <Column
              sortable
              field="di_tangani_id"
              header="Ditangani"
              headerClassName={head()}
              body={diTanganiBodyTemplate}
            />
          )}
        </DataTable>
      </div>
    </div>
  );
};

export default ProblemTableCard;
